import styled from 'styled-components';
import { colors } from 'global/colors';

export const InputAndSearchSection = styled.div`
  padding: 30px 0 30px 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const InputSection = styled.div`
  display: flex;
  align-items: baseline;
`;

export const CreditsTag = styled.span`
  border-radius: 10%;
  display: inline-block;
  padding: 0.25em 0.45em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1.25;
  border: 0px;
  color: white;
  background: ${(props) => (props.isPositive ? colors.green2 : colors.red)};
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  margin: 2px;
`;
